import { standardTitle } from '../../../../form0781/content';

/**
 * Intro page. A `required` arrayBuilder loop must include an intro page, but
 * this one never displays (intro-bypass pattern).
 */
export default {
  uiSchema: {
    'ui:title': standardTitle('Upload your service treatment records'),
  },
  schema: {
    type: 'object',
    properties: {},
  },
};
